var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_450_961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 19C2 9.05888 10.0589 1 20 1C29.9411 1 38 9.05888 38 19C38 28.9411 29.9411 37 20 37C10.0589 37 2 28.9411 2 19Z",
    fill: "#2B303B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 19C2.5 9.33502 10.335 1.5 20 1.5C29.665 1.5 37.5 9.33502 37.5 19C37.5 28.665 29.665 36.5 20 36.5C10.335 36.5 2.5 28.665 2.5 19Z",
    stroke: "#0E121B",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 23.5C23.2961 23.5 26.1788 24.9175 27.7466 27.0325L26.0888 27.8164C24.8126 26.3044 22.5626 25.3 20.0003 25.3C17.438 25.3 15.188 26.3044 13.9118 27.8164L12.2549 27.0316C13.8227 24.9166 16.7045 23.5 20.0003 23.5ZM20.0003 10C21.1938 10 22.3383 10.4741 23.1823 11.318C24.0262 12.1619 24.5003 13.3065 24.5003 14.5V17.2C24.5002 18.3596 24.0525 19.4744 23.2505 20.312C22.4485 21.1496 21.3541 21.6452 20.1956 21.6955L20.0003 21.7C18.8068 21.7 17.6622 21.2259 16.8183 20.382C15.9744 19.5381 15.5003 18.3935 15.5003 17.2V14.5C15.5003 13.3404 15.9481 12.2256 16.7501 11.388C17.5521 10.5504 18.6465 10.0548 19.805 10.0045L20.0003 10ZM20.0003 11.8C19.3116 11.8 18.6489 12.0631 18.1478 12.5356C17.6468 13.008 17.3452 13.6541 17.3048 14.3416L17.3003 14.5V17.2C17.2996 17.9028 17.573 18.5782 18.0624 19.0826C18.5518 19.5871 19.2185 19.8808 19.921 19.9014C20.6236 19.9221 21.3064 19.6679 21.8246 19.1931C22.3427 18.7182 22.6552 18.06 22.6958 17.3584L22.7003 17.2V14.5C22.7003 13.7839 22.4158 13.0972 21.9095 12.5908C21.4031 12.0845 20.7164 11.8 20.0003 11.8Z",
    fill: "#99A0AE"
  }))), "\n    {/* ", _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_450_961",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0509804 0 0 0 0 0.0784314 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_450_961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_450_961",
    result: "shape"
  })))), " */}\n");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvator);
export default __webpack_public_path__ + "static/media/avator.9a202ecdb6a60e391e28111f4e02d7e0.svg";
export { ForwardRef as ReactComponent };